var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.686 17.034c4.621 0 8.382-3.704 8.382-8.259S20.308.516 15.686.516s-8.382 3.706-8.382 8.26c0 4.553 3.76 8.258 8.382 8.258m3.454.796h-6.28c-5.837 0-10.584 4.674-10.584 10.42v.62c0 3.003 4.671 3.003 10.583 3.003h6.28c5.68 0 10.585 0 10.585-3.004v-.619c0-5.745-4.748-10.42-10.584-10.42"
  })));
};
export default SvgUser;